<template>
  <el-dialog
    :visible.sync="dialogShow"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
    width="620px"
    title="短信推送充值"
    custom-class="smsrechagre-dialog"
    append-to-body
    destroy-on-close
  >
    <template #default>

      <!-- 创建订单 -->
      <div v-show="step === 'createorder'" class="step-item">
        <div
          v-loading="queryPriceListing"
          class="price-container"
          element-loading-text="正在加载套餐列表"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
        >
          <el-radio-group v-model="rechargePriceId" @change="priceManager().priceChoseCall()">
            <el-radio
              v-for="(item, index) in priceList"
              :key="index"
              :label="item.id"
              border
            >
              {{ item.smsnumber }}条/￥{{ (item.price - item.preferential).toFixed(2) }}
            </el-radio>
          </el-radio-group>
        </div>
      </div>

      <!-- 支付订单 -->
      <div v-show="step === 'payorder'" class="step-item">
        <p class="p-descript">
          <span>{{ $t('text.amountpayable') }}: ￥{{ totalprice }}</span>
        </p>
        <p class="p-descript">
          {{ $t('text.rmainingpaymenttime') }}<span>{{ payManager.orderCountdownString }}，{{
            $t('text.ordercancelledalert') }}</span>
        </p>
        <div
          v-loading="createOrderIng"
          :style="{ height: '155px', width: '152px', margin: '5px auto' }"
          :element-loading-text="$t('text.generatingorder')"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
        >
          <iframe
            v-if="iframeQrcode"
            :srcdoc="iframeQrcode"
            :style="{ height: '155px', width: '152px' }"
            @load="orderManager().orderLoaded()"
          />
        </div>
        <p class="p-descript">
          <span>{{ $t('text.onlyalipay') }}</span>
        </p>
        <p class="p-descript">
          <img src="../../../assets/icon/zfb.png" alt="">
        </p>
      </div>

      <!-- 支付成功 -->
      <div v-show="step === 'paysuccess'" class="step-item">
        <el-result icon="success">
          <template #title>
            <p class="p-descript">{{ $t('text.paymentsucceeded') }}</p>
          </template>
          <template #extra>
            <el-button
              type="primary"
              class="btn-primary"
              size="medium"
              @click="() => {
                handleClose();
                $emit('paysuccess')
              }"
            >{{ $t('button.qd') }}</el-button>
          </template>
        </el-result>
      </div>

      <!-- 订单过期 -->
      <div v-show="step === 'orderexpire'" class="step-item">
        <el-result icon="warning">
          <template #title>
            <p class="p-descript">{{ $t('text.orderexpirednotify') }}</p>
          </template>
          <template #extra>
            <el-button
              type="primary"
              class="btn-primary"
              size="medium"
              @click="() => {
                handleClose();
                $emit('orderexpire')
              }"
            >{{ $t('button.qd') }}</el-button>
          </template>
        </el-result>
      </div>
    </template>
    <template #footer>
      <el-button
        v-show="step === 'createorder'"
        type="primary"
        class="btn-primary"
        :loading="createOrderIng"
        @click="orderManager().createOrder()"
      >立即支付￥{{ totalprice }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { SmsPriceList } from '@/api/Payment/actions'
import { Message } from 'element-ui'
import PayManager from '@/utils/paymanager'
export default {
  name: 'SmsRechargeDialog',
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      /** 步骤 */
      step: 'createorder',
      /** 应支付金额 */
      totalprice: 0,
      /** 获取套餐列表中 */
      queryPriceListing: true,
      /** 套餐列表 */
      priceList: [],
      /** 套餐主键 */
      rechargePriceId: '',
      /** 是否创建订单中 */
      createOrderIng: false,
      /** 支付宝订单二维码 */
      iframeQrcode: '',
      /** 支付管理 */
      payManager: null,
      /** 模态框关闭倒计时 */
      dialogCloseCountDown: 3
    }
  },
  created () {
    this.initPayManager()
    this.priceManager().querySmsPrice()
  },

  methods: {

    /** 初始化支付管理 */
    initPayManager () {
      const options = {
        userid: this.$store.getters.id,
        paySuccessCall: () => {
          this.orderManager().paySuccessCall()
        },
        orderExpireCall: () => {
          this.orderManager().orderExpireCall()
        },
      }
      this.payManager = new PayManager(options)
    },

    /** 套餐价格 */
    priceManager () {
      return {
        /** 获取短信充值价格套餐列表 */
        querySmsPrice: () => {
          this.queryPriceListing = true
          SmsPriceList().then(response => {
            this.queryPriceListing = false
            this.priceList = response.data || []
            if (this.priceList.length > 0) {
              this.rechargePriceId = this.priceList[0].id
              this.priceManager().priceChoseCall()
            }
          }).catch(error => {
            this.queryPriceListing = false
            Message.error(`获取价格套餐失败:${error}`)
          })
        },

        /** 套餐选择回调 */
        priceChoseCall: () => {
          const priceData = this.priceList.find(item => this.rechargePriceId === item.id)
          this.totalprice = (priceData.price - priceData.preferential).toFixed(2)
        }
      }
    },

    /** 订单 */
    orderManager () {
      return {

        /** 创建订单 */
        createOrder: () => {
          this.createOrderIng = true
          const orderForm = {
            payOrderTitle: "离线推送短信充值",
            payTotalAmount: this.totalprice,
            rechargePriceId: this.rechargePriceId
          }
          this.payManager.smsRecharge(orderForm).then(response => {
            this.orderManager().createOrderCall(response)
          }).catch((error) => {
            Message.error(error)
            this.createOrderIng = false
          })
        },

        /** 创建订单回调 */
        createOrderCall: (iframeOrCode) => {
          this.iframeQrcode = iframeOrCode
          this.step = 'payorder'
        },

        /** 订单加载完成 */
        orderLoaded: () => {
          this.createOrderIng = false
        },

        /** 订单支付成功 */
        paySuccessCall: () => {
          this.step = 'paysuccess'
          this.payManager.clearOrderPay()
          this.iframeQrcode = ''
        },

        /** 订单过期 */
        orderExpireCall: () => {
          this.step = 'orderexpire'
          this.payManager.clearOrderPay()
          this.iframeQrcode = ''
        }
      }
    },

    /** 关闭模态框 */
    handleClose () {
      this.payManager.clearOrderPay()
      this.iframeQrcode = ''
      this.step = 'createorder'
      this.$emit('update:dialogShow', false)
    }
  }
}

</script>

<style lang="stylus" scoped>
.smsrechagre-dialog
    .step-item
        width: 100%
        height: fit-content
        .title
            font-size: 14px
            color: #4fce6e
        .price-container
            width: 100%
            min-height: 200px
            .el-radio
                border-color: #4fce6e
            .is-checked
                background-color: #4fce6e
        .p-descript
            text-align: center
            color: #1cc197
    .btn-primary
        background-color: #4fce6e
        border-color: #4fce6e
</style>

<style lang="stylus">
.smsrechagre-dialog
    .el-dialog__header
        border-bottom: thin solid #4fce6e
        .el-dialog__title
            font-size: 14px
    .el-dialog__body
        padding: 20px
        .price-container
            .el-radio
                width: 155px
                margin: 5px 10px
                .el-radio__input
                    display: none
                .el-radio__label
                    color: #4fce6e
            .is-checked
                .el-radio__label
                    color: white
</style>
